export default "__VITE_ASSET__CN8GK0DE__"